export default "__VITE_ASSET__db5df38b__"